import CommonProperties from "./commonProperties";
class DocumentMapDataGeometry extends CommonProperties {
    constructor(Id, MapGeometryType, Points, Created, Name, Description, Color) {
        super(Created, Description, Color);
        this.Id = Id;
        this.MapGeometryType = MapGeometryType;
        this.Points = Points;
        this.Name = Name;
    }
}
export default DocumentMapDataGeometry;
